define(function(require,exports,module){

    var originalColor = [];

    function isPlaceholder() {
        var input = document.createElement('input');
        return 'placeholder' in input;
    }

    function changeToOriginalColor(self) {
        var index = $(self).index();
        var color = originalColor[$(self).index()];
        $(self).css('color', color);
    }

    exports.init = function(defaultColor) {
        defaultColor = defaultColor || "#666";
        var texts = $(':text');
        if(!isPlaceholder()) {
            var len = texts.length;
            for(var i = 0; i < len; i++) {
                var self = texts[i];
                var placeholder = $(self).attr('placeholder');
                if($(self).val() == "" && placeholder != null) {
                    $(self).val(placeholder);
                    originalColor[i] = $(self).css('color');
                    $(self).css('color', defaultColor);
                }
            }
        } 

        texts.focus(function() {
            if($(this).attr('placeholder') != null && $(this).val() == $(this).attr('placeholder')) {
                $(this).val('');
                changeToOriginalColor(this);
            }
        }).blur(function() {
            if($(this).attr('placeholder') != null && ($(this).val() == '' || $(this).val() == $(this).attr('placeholder')) && !$(this).hasClass("shutdown")) {
                $(this).val($(this).attr('placeholder'));
                $(this).css('color', defaultColor);
            }
        });
    }

});


// WEBPACK FOOTER //
// ./src/js/unit/placeholder/placeholder.js